import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import 'babel-polyfill';
import { IProvider, Coords } from './interfaces';
import MiniSchedule from './minischedule';
import { MarkerClusterer, Cluster } from "@googlemaps/markerclusterer";
import { } from 'googlemaps';
import { addQueryParam, formatPhone } from './util';

interface IProps {
    providers: IProvider[];
    totalProviders: number;
    markerCluster?: MarkerClusterer;
    lat: string;
    lng: string;
    place: string;
    isLoading: boolean;
    reason: string;
    rowEnter: Function;
    rowLeave: Function;
    apptType?: string;
    backto?: string;
    who?: string;
    age?: string;
}

const SearchResults = (props: IProps) => {    
    if (props.isLoading) {
        return (<div>Loading...</div>);
    }
    if (props.providers.length == 0) {
        return (
            <div>No providers found matching criteria. Please try a <a href={`./search?age=${props.age}`}>new search</a>{props.totalProviders >= 0 && " or modify filters above."}</div>
            )
    }

    return (        
        <div className="container px-0">
            {props.providers.slice(0, 50).map((p, i, a) => {
                let providerParams = `?npi=${p.npi}&deptid=${p.departmentId}&backto=${props.backto}`
                    + (props.apptType ? `&apptType=${props.apptType}` : "")                    
                return (<>
                    <div className="row mb-4"
                        onMouseEnter={() => { if (!('ontouchstart' in window)) props.rowEnter(p) }}
                        onMouseLeave={() => { if (!('ontouchstart' in window)) props.rowLeave() }}>
                        <div className="col-xl-7">
                            <div className="row g-4 row-cols-1">
                                <div className="col d-flex align-items-start">
                                    <div className="icon-square text-dark flex-shrink-0 me-3 pr-3" style={{ maxWidth: "120px", marginRight: "20px" }}>
                                        <Link to={{ pathname: "/provider", search: providerParams }}>
                                            <img className="py-1" src={(window as any).PHOTO_URL + (p.photo ? p.photo : (p.gender === "M" ? "m00000000.jpg" : "f00000000.jpg"))} width="120" />
                                        </Link><br />
                                        {p.languageList.map(l => (<><span className="badge bg-secondary" style={{ color: "white" }}>{l}</span> </>))}
                                    </div>

                                    <div>
                                        <h2 className="provider-name"><Link to={{ pathname: "/provider", search: providerParams }}>{p.firstName + " " + p.lastName}{p.academicTitle && (", " + p.academicTitle)}</Link></h2>
                                        {/*<p>{p.certification && p.certification.split("|").join(", ")}</p>*/}
                                        <p className="mb-0">
                                            <div className="mb-1">
                                            {p.clinic}<br />
                                            {p.clinicOldName && <span style={{ fontSize: "80%"}}><em>formerly {p.clinicOldName}</em><br /></span>}
                                            </div>
                                            {p.virtualist ? <div className="mt-2 mb-2"><img src="img/icon_vv.png" width="15" alt="Virtual Primary Care Only"
                                                title="Virtual Primary Care Only" style={{ display: "inline-block", verticalAlign: "middle" }}
                                            /> <span style={{ display: "inline-block", verticalAlign: "middle", color: "var(--primary-color)", fontWeight: "bold", fontSize: "1.2rem" }}>Virtual Primary Care Only</span></div> : <>
                                                {p.address1}<br />
                                                {p.city}, {p.state} {p.zipCode}<br /></>                                                
                                            }                                            
                                            Phone: <a href={"tel:" + formatPhone(p.phone)}>{formatPhone(p.phone)}</a></p>
                                        {p.virtualVisit && <div></div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 px-0">
                            <MiniSchedule key={p.npi} clinic={p.clinic} phone={formatPhone(p.phone)} availability={p.availability} npi={p.npi} deptid={p.departmentId} apptType={props.apptType} reason={props.reason} backto={props.backto} who={props.who} />
                            <div style={{ textAlign: "right", fontSize: "80%", paddingRight: "15px" }}><Link to={{ pathname: "/provider", search: providerParams }} className="btn btn-sm" style={{ fontWeight: "bold", color: "#333", lineHeight: "1" }}>...</Link></div>
                        </div>
                    </div>
                    {(i < (a.length - 1)) && <hr className="mb-4" />}
                </>)
            })}
        </div>            
    );
}

export default SearchResults;